// This file was automatically generated from ptdata.model.medOrderThread.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.model.medOrderThread');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.core');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrderThread.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((! opt_data.isActive) ? 'D/C\'d ' : '');
  if (opt_data.isRxDownload) {
    el8.template.core.newTag(null, output);
  }
  output.append((opt_data.hasTrigger) ? '<a class="details-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">' : '', soy.$$escapeHtml(opt_data.latestOrder.displayedMedicationName), (opt_data.isActive) ? (opt_data.latestOrder.directions) ? ' ' + soy.$$escapeHtml(opt_data.latestOrder.directions) : '' : '', (opt_data.hasTrigger) ? '</a>' : '');
  if (!opt_sb) return output.toString();
};
